import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX } from 'react-icons/fi';
import globalButtonStyles from '../../styles/ButtonGradient.module.css';
import styles from './AthleteInviteModal.module.css';

const AthleteInviteModal = ({ isOpen, onClose, onInvite }) => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      onInvite(email);
      setEmail(''); 
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={styles.overlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={styles.modal}
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <button className={styles.closeButton} onClick={onClose} aria-label="Close modal">
              <FiX />
            </button>
            <h2 className={styles.heading}>Invite an Athlete</h2>
            <form onSubmit={handleSubmit} className={styles.form}>
              <input
                type="email"
                placeholder="Athlete's Email"
                className={styles.input}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className={`${globalButtonStyles.button} ${styles.inviteButton}`}>
                Invite
              </button>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AthleteInviteModal;